/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RankControllerDtoRankDetailSettingListListData model module.
 * @module model/RankControllerDtoRankDetailSettingListListData
 * @version 1.0
 */
class RankControllerDtoRankDetailSettingListListData {
    /**
     * Constructs a new <code>RankControllerDtoRankDetailSettingListListData</code>.
     * @alias module:model/RankControllerDtoRankDetailSettingListListData
     */
    constructor() { 
        
        RankControllerDtoRankDetailSettingListListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RankControllerDtoRankDetailSettingListListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RankControllerDtoRankDetailSettingListListData} obj Optional instance to populate.
     * @return {module:model/RankControllerDtoRankDetailSettingListListData} The populated <code>RankControllerDtoRankDetailSettingListListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RankControllerDtoRankDetailSettingListListData();

            if (data.hasOwnProperty('settingNo')) {
                obj['settingNo'] = ApiClient.convertToType(data['settingNo'], 'Number');
            }
            if (data.hasOwnProperty('rankType')) {
                obj['rankType'] = ApiClient.convertToType(data['rankType'], 'Number');
            }
            if (data.hasOwnProperty('lastRank')) {
                obj['lastRank'] = ApiClient.convertToType(data['lastRank'], 'Number');
            }
            if (data.hasOwnProperty('targetType')) {
                obj['targetType'] = ApiClient.convertToType(data['targetType'], 'Number');
            }
            if (data.hasOwnProperty('withoutTarget')) {
                obj['withoutTarget'] = ApiClient.convertToType(data['withoutTarget'], 'String');
            }
            if (data.hasOwnProperty('rankDetail')) {
                obj['rankDetail'] = ApiClient.convertToType(data['rankDetail'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>RankControllerDtoRankDetailSettingListListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RankControllerDtoRankDetailSettingListListData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['withoutTarget'] && !(typeof data['withoutTarget'] === 'string' || data['withoutTarget'] instanceof String)) {
            throw new Error("Expected the field `withoutTarget` to be a primitive type in the JSON string but got " + data['withoutTarget']);
        }
        // ensure the json data is a string
        if (data['rankDetail'] && !(typeof data['rankDetail'] === 'string' || data['rankDetail'] instanceof String)) {
            throw new Error("Expected the field `rankDetail` to be a primitive type in the JSON string but got " + data['rankDetail']);
        }

        return true;
    }


}



/**
 * @member {Number} settingNo
 */
RankControllerDtoRankDetailSettingListListData.prototype['settingNo'] = undefined;

/**
 * @member {Number} rankType
 */
RankControllerDtoRankDetailSettingListListData.prototype['rankType'] = undefined;

/**
 * @member {Number} lastRank
 */
RankControllerDtoRankDetailSettingListListData.prototype['lastRank'] = undefined;

/**
 * @member {Number} targetType
 */
RankControllerDtoRankDetailSettingListListData.prototype['targetType'] = undefined;

/**
 * @member {String} withoutTarget
 */
RankControllerDtoRankDetailSettingListListData.prototype['withoutTarget'] = undefined;

/**
 * @member {String} rankDetail
 */
RankControllerDtoRankDetailSettingListListData.prototype['rankDetail'] = undefined;






export default RankControllerDtoRankDetailSettingListListData;

